import { getTypographyStyles, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_50, SYS_SIZE_FIXED_800, getMargins, SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_NORMAL, SYS_BORDER_RADIUS_MAX, SYS_SIZE_FIXED_600 } from '@oneaudi/unified-web-alpha-common';
import styled, { css } from 'styled-components';
import {} from './index.js';
const InteractiveBackground = css `
  &::before {
    // TODO: missing token
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
    transition-duration: 250ms;
    transition-property: background-color;
    z-index: -1;
    content: '';
    display: block;
    position: absolute;
    background-color: transparent;
    border-radius: ${SYS_BORDER_RADIUS_MAX};
  }
`;
export const StyledIconContainer = styled.span `
  line-height: 0;
  ${InteractiveBackground}

  &::before {
    height: ${SYS_SIZE_FIXED_600};
    width: ${SYS_SIZE_FIXED_600};
  }
`;
export const StyledPaginationContainer = styled.nav `
  margin: ${(props) => getMargins(props.margin)};
  display: inline-flex;
  ${getTypographyStyles(SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_NORMAL)}

  ${(props) => (props.variant === 'compact' || props.variant === 'minimal') &&
    css `
      align-items: center;
      gap: ${props.hasLabel ? SYS_SPACE_FIXED_200 : SYS_SPACE_FIXED_100};
    `}
`;
export const StyledList = styled.ul `
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${(props) => props.hasLabel ? SYS_SPACE_FIXED_200 : SYS_SPACE_FIXED_100};
  padding: 0;
  margin: 0;
`;
export const StyledNumber = styled.span `
  position: relative;
`;
export const StyledListItem = styled.li `
  display: flex;
  justify-content: center;
  min-width: ${SYS_SIZE_FIXED_800};
  color: ${(props) => props.isActive
    ? props.theme.sem.color.navigation.foreground.text.active
    : props.theme.sem.color.navigation.foreground.text.idle};

  &:hover,
  &:active {
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.interactive};
  }

  // TODO: token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color;

  ${(props) => props.isActive &&
    css `
      ${StyledNumber} {
        &:before {
          content: '';
          position: absolute;
          background-color: ${(props) => props.theme.sem.color.navigation.foreground.indicator.active};
          width: 100%;
          height: 2px;
          bottom: -2px;
        }
      }
    `}
`;
export const StyledCompactNumber = styled.div `
  color: ${(props) => props.theme.sem.color.navigation.foreground.text.idle};
  min-width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    color: ${(props) => props.theme.sem.color.navigation.foreground.text.active};
  }
`;
export const StyledAnchor = styled.a `
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;
  height: ${SYS_SIZE_FIXED_800};
  width: ${SYS_SIZE_FIXED_800};
  flex-shrink: 0;
  ${InteractiveBackground}

  &::before {
    height: ${SYS_SIZE_FIXED_800};
    width: ${SYS_SIZE_FIXED_800};
  }

  &:active {
    background-color: ${(props) => props.theme.sem.color.navigation.surface.fill.pressed};
  }

  &:hover,
  &:active {
    &::before {
      background-color: ${(props) => props.theme.sem.color.navigation.surface.fill.interactive};
    }
  }
`;
export const StyledButton = styled.button `
  background-color: transparent;
  cursor: pointer;
  border: none;
  font: inherit;
  padding: ${(props) => (props.hasLabel ? SYS_SPACE_FIXED_50 : 0)};
  gap: ${(props) => (props.hasLabel ? SYS_SPACE_FIXED_100 : 0)};
  color: inherit;
  height: ${(props) => (props.hasLabel ? 'auto' : SYS_SIZE_FIXED_800)};
  width: ${(props) => (props.hasLabel ? 'auto' : SYS_SIZE_FIXED_800)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  ${(props) => props.variant !== 'minimal' &&
    css `
      ${InteractiveBackground}

      &::before {
        height: ${SYS_SIZE_FIXED_600};
        width: ${SYS_SIZE_FIXED_600};
      }
    `}

  &:active:not(:disabled) {
    background-color: ${(props) => props.theme.sem.color.navigation.surface.fill.pressed};

    ${(props) => {
    if (props.variant !== 'minimal') {
        return css `
          &::before {
            background-color: ${(props) => props.theme.sem.color.navigation.surface.fill.interactive};
          }
        `;
    }
    return css `
        ${StyledIconContainer} {
          &::before {
            background-color: ${(props) => props.theme.sem.color.navigation.surface.fill.interactive};
          }
        }
      `;
}}
  }

  &:disabled {
    color: ${(props) => props.theme.sem.color.navigation.foreground.icon.disabled};
    cursor: not-allowed;
  }
`;
export const StyledVisuallyHiddenPrefix = styled.div `
  border: 0;
  clip: rect(0 0 0 0);
  -webkit-clip-path: inset(100%);
  clip-path: inset(100%);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
//# sourceMappingURL=index.styles.js.map